import { MonetizationType, ObjectType, PresentationType } from '@/@types/graphql-types';

export type DvdBluRayTextPlaceholderStreamingState = 'with-streaming' | 'no-streaming';

// The Structure of the keys must follow "DVD-[...sortedMonetizationTypes]-BLURAY-[...sortedMonetizationTypes]" (in case this changes also change sortedMonetizationTypes and sortedPresentationTypes)
export type DvdBluRayTextPlaceholderOfferKey =
	| 'DVD-BUY'
	| 'DVD-RENT'
	| 'DVD-BUY-RENT'
	| 'BLURAY-BUY'
	| 'BLURAY-RENT'
	| 'BLURAY-BUY-RENT'
	| 'DVD-BUY-BLURAY-BUY'
	| 'DVD-RENT-BLURAY-RENT'
	| 'DVD-BUY-BLURAY-RENT'
	| 'DVD-RENT-BLURAY-BUY'
	| 'DVD-BUY-RENT-BLURAY-BUY'
	| 'DVD-BUY-RENT-BLURAY-BUY-RENT';
type Placeholders = Record<DvdBluRayTextPlaceholderStreamingState, Record<DvdBluRayTextPlaceholderOfferKey, string>>;

export const sortedPresentationTypes = [PresentationType.Dvd, PresentationType.Bluray];
export const sortedMonetizationTypes = [MonetizationType.Buy, MonetizationType.Rent];

const $t = (key: string) => key;

const TextPlaceHolder = {
	[ObjectType.Movie]: {
		'with-streaming': {
			'DVD-BUY': $t('WEBAPP_MOVIE_WITH_STREAMING_DVD_BUY'),
			'DVD-RENT': $t('WEBAPP_MOVIE_WITH_STREAMING_DVD_RENT'),
			'DVD-BUY-RENT': $t('WEBAPP_MOVIE_WITH_STREAMING_DVD_BUY_RENT'),

			'BLURAY-BUY': $t('WEBAPP_MOVIE_WITH_STREAMING_BLURAY_BUY'),
			'BLURAY-RENT': $t('WEBAPP_MOVIE_WITH_STREAMING_BLURAY_RENT'),
			'BLURAY-BUY-RENT': $t('WEBAPP_MOVIE_WITH_STREAMING_BLURAY_BUY_RENT'),

			'DVD-BUY-BLURAY-BUY': $t('WEBAPP_MOVIE_WITH_STREAMING_DVD_BUY_BLURAY_BUY'),
			'DVD-RENT-BLURAY-RENT': $t('WEBAPP_MOVIE_WITH_STREAMING_DVD_RENT_BLURAY_RENT'),
			'DVD-BUY-BLURAY-RENT': $t('WEBAPP_MOVIE_WITH_STREAMING_DVD_BUY_BLURAY_RENT'),
			'DVD-RENT-BLURAY-BUY': $t('WEBAPP_MOVIE_WITH_STREAMING_DVD_RENT_BLURAY_BUY'),
			'DVD-BUY-RENT-BLURAY-BUY': $t('WEBAPP_MOVIE_WITH_STREAMING_DVD_BUY_RENT_BLURAY_BUY'),
			'DVD-BUY-RENT-BLURAY-BUY-RENT': $t('WEBAPP_MOVIE_WITH_STREAMING_DVD_BUY_RENT_BLURAY_BUY_RENT'),
		},
		'no-streaming': {
			'DVD-BUY': $t('WEBAPP_MOVIE_NO_STREAMING_DVD_BUY'),
			'DVD-RENT': $t('WEBAPP_MOVIE_NO_STREAMING_DVD_RENT'),
			'DVD-BUY-RENT': $t('WEBAPP_MOVIE_NO_STREAMING_DVD_BUY_RENT'),

			'BLURAY-BUY': $t('WEBAPP_MOVIE_NO_STREAMING_BLURAY_BUY'),
			'BLURAY-RENT': $t('WEBAPP_MOVIE_NO_STREAMING_BLURAY_RENT'),
			'BLURAY-BUY-RENT': $t('WEBAPP_MOVIE_NO_STREAMING_BLURAY_BUY_RENT'),

			'DVD-BUY-BLURAY-BUY': $t('WEBAPP_MOVIE_NO_STREAMING_DVD_BUY_BLURAY_BUY'),
			'DVD-RENT-BLURAY-RENT': $t('WEBAPP_MOVIE_NO_STREAMING_DVD_RENT_BLURAY_RENT'),
			'DVD-BUY-BLURAY-RENT': $t('WEBAPP_MOVIE_NO_STREAMING_DVD_BUY_BLURAY_RENT'),
			'DVD-RENT-BLURAY-BUY': $t('WEBAPP_MOVIE_NO_STREAMING_DVD_RENT_BLURAY_BUY'),
			'DVD-BUY-RENT-BLURAY-BUY': $t('WEBAPP_MOVIE_NO_STREAMING_DVD_BUY_RENT_BLURAY_BUY'),
			'DVD-BUY-RENT-BLURAY-BUY-RENT': $t('WEBAPP_MOVIE_NO_STREAMING_DVD_BUY_RENT_BLURAY_BUY_RENT'),
		},
	},
	[ObjectType.Show]: {
		'with-streaming': {
			'DVD-BUY': $t('WEBAPP_SHOW_WITH_STREAMING_DVD_BUY'),
			'DVD-RENT': $t('WEBAPP_SHOW_WITH_STREAMING_DVD_RENT'),
			'DVD-BUY-RENT': $t('WEBAPP_SHOW_WITH_STREAMING_DVD_BUY_RENT'),

			'BLURAY-BUY': $t('WEBAPP_SHOW_WITH_STREAMING_BLURAY_BUY'),
			'BLURAY-RENT': $t('WEBAPP_SHOW_WITH_STREAMING_BLURAY_RENT'),
			'BLURAY-BUY-RENT': $t('WEBAPP_SHOW_WITH_STREAMING_BLURAY_BUY_RENT'),

			'DVD-BUY-BLURAY-BUY': $t('WEBAPP_SHOW_WITH_STREAMING_DVD_BUY_BLURAY_BUY'),
			'DVD-RENT-BLURAY-RENT': $t('WEBAPP_SHOW_WITH_STREAMING_DVD_RENT_BLURAY_RENT'),
			'DVD-BUY-BLURAY-RENT': $t('WEBAPP_SHOW_WITH_STREAMING_DVD_BUY_BLURAY_RENT'),
			'DVD-RENT-BLURAY-BUY': $t('WEBAPP_SHOW_WITH_STREAMING_DVD_RENT_BLURAY_BUY'),
			'DVD-BUY-RENT-BLURAY-BUY': $t('WEBAPP_SHOW_WITH_STREAMING_DVD_BUY_RENT_BLURAY_BUY'),
			'DVD-BUY-RENT-BLURAY-BUY-RENT': $t('WEBAPP_SHOW_WITH_STREAMING_DVD_BUY_RENT_BLURAY_BUY_RENT'),
		},
		'no-streaming': {
			'DVD-BUY': $t('WEBAPP_SHOW_NO_STREAMING_DVD_BUY'),
			'DVD-RENT': $t('WEBAPP_SHOW_NO_STREAMING_DVD_RENT'),
			'DVD-BUY-RENT': $t('WEBAPP_SHOW_NO_STREAMING_DVD_BUY_RENT'),

			'BLURAY-BUY': $t('WEBAPP_SHOW_NO_STREAMING_BLURAY_BUY'),
			'BLURAY-RENT': $t('WEBAPP_SHOW_NO_STREAMING_BLURAY_RENT'),
			'BLURAY-BUY-RENT': $t('WEBAPP_SHOW_NO_STREAMING_BLURAY_BUY_RENT'),

			'DVD-BUY-BLURAY-BUY': $t('WEBAPP_SHOW_NO_STREAMING_DVD_BUY_BLURAY_BUY'),
			'DVD-RENT-BLURAY-RENT': $t('WEBAPP_SHOW_NO_STREAMING_DVD_RENT_BLURAY_RENT'),
			'DVD-BUY-BLURAY-RENT': $t('WEBAPP_SHOW_NO_STREAMING_DVD_BUY_BLURAY_RENT'),
			'DVD-RENT-BLURAY-BUY': $t('WEBAPP_SHOW_NO_STREAMING_DVD_RENT_BLURAY_BUY'),
			'DVD-BUY-RENT-BLURAY-BUY': $t('WEBAPP_SHOW_NO_STREAMING_DVD_BUY_RENT_BLURAY_BUY'),
			'DVD-BUY-RENT-BLURAY-BUY-RENT': $t('WEBAPP_SHOW_NO_STREAMING_DVD_BUY_RENT_BLURAY_BUY_RENT'),
		},
	},
	[ObjectType.ShowSeason]: {
		'with-streaming': {
			'DVD-BUY': $t('WEBAPP_SEASON_WITH_STREAMING_DVD_BUY'),
			'DVD-RENT': $t('WEBAPP_SEASON_WITH_STREAMING_DVD_RENT'),
			'DVD-BUY-RENT': $t('WEBAPP_SEASON_WITH_STREAMING_DVD_BUY_RENT'),

			'BLURAY-BUY': $t('WEBAPP_SEASON_WITH_STREAMING_BLURAY_BUY'),
			'BLURAY-RENT': $t('WEBAPP_SEASON_WITH_STREAMING_BLURAY_RENT'),
			'BLURAY-BUY-RENT': $t('WEBAPP_SEASON_WITH_STREAMING_BLURAY_BUY_RENT'),

			'DVD-BUY-BLURAY-BUY': $t('WEBAPP_SEASON_WITH_STREAMING_DVD_BUY_BLURAY_BUY'),
			'DVD-RENT-BLURAY-RENT': $t('WEBAPP_SEASON_WITH_STREAMING_DVD_RENT_BLURAY_RENT'),
			'DVD-BUY-BLURAY-RENT': $t('WEBAPP_SEASON_WITH_STREAMING_DVD_BUY_BLURAY_RENT'),
			'DVD-RENT-BLURAY-BUY': $t('WEBAPP_SEASON_WITH_STREAMING_DVD_RENT_BLURAY_BUY'),
			'DVD-BUY-RENT-BLURAY-BUY': $t('WEBAPP_SEASON_WITH_STREAMING_DVD_BUY_RENT_BLURAY_BUY'),
			'DVD-BUY-RENT-BLURAY-BUY-RENT': $t('WEBAPP_SEASON_WITH_STREAMING_DVD_BUY_RENT_BLURAY_BUY_RENT'),
		},
		'no-streaming': {
			'DVD-BUY': $t('WEBAPP_SEASON_NO_STREAMING_DVD_BUY'),
			'DVD-RENT': $t('WEBAPP_SEASON_NO_STREAMING_DVD_RENT'),
			'DVD-BUY-RENT': $t('WEBAPP_SEASON_NO_STREAMING_DVD_BUY_RENT'),

			'BLURAY-BUY': $t('WEBAPP_SEASON_NO_STREAMING_BLURAY_BUY'),
			'BLURAY-RENT': $t('WEBAPP_SEASON_NO_STREAMING_BLURAY_RENT'),
			'BLURAY-BUY-RENT': $t('WEBAPP_SEASON_NO_STREAMING_BLURAY_BUY_RENT'),

			'DVD-BUY-BLURAY-BUY': $t('WEBAPP_SEASON_NO_STREAMING_DVD_BUY_BLURAY_BUY'),
			'DVD-RENT-BLURAY-RENT': $t('WEBAPP_SEASON_NO_STREAMING_DVD_RENT_BLURAY_RENT'),
			'DVD-BUY-BLURAY-RENT': $t('WEBAPP_SEASON_NO_STREAMING_DVD_BUY_BLURAY_RENT'),
			'DVD-RENT-BLURAY-BUY': $t('WEBAPP_SEASON_NO_STREAMING_DVD_RENT_BLURAY_BUY'),
			'DVD-BUY-RENT-BLURAY-BUY': $t('WEBAPP_SEASON_NO_STREAMING_DVD_BUY_RENT_BLURAY_BUY'),
			'DVD-BUY-RENT-BLURAY-BUY-RENT': $t('WEBAPP_SEASON_NO_STREAMING_DVD_BUY_RENT_BLURAY_BUY_RENT'),
		},
	},
};

export function getDvdBlurRaySpinningTextPlaceHolder(
	objectType: ObjectType.Movie | ObjectType.Show | ObjectType.ShowSeason
): Placeholders {
	return TextPlaceHolder[objectType];
}
